import { Extension } from '@tiptap/core';
import { Plugin, PluginKey } from '@tiptap/pm/state';

export const AutoCapitalize = Extension.create({
  name: 'autoCapitalize',
  addProseMirrorPlugins() {
    return [
      new Plugin({
        key: new PluginKey('autoCapitalizePlugin'),
        appendTransaction: (transactions, oldState, newState) => {
          if (!transactions.some(tr => tr.docChanged)) return null;

          const lastTr = transactions[transactions.length - 1];
          let isSpaceInput = false;

          lastTr.steps.forEach((step: any) => {
            if (step.slice?.content?.content?.[0]?.text === ' ') {
              isSpaceInput = true;
            }
          });

          if (!isSpaceInput) return null;

          const { selection } = newState;
          const node = selection.$anchor.parent;

          if (node.firstChild.type.name !== 'text') return;

          const text = node.textContent;
          const firstWordWithSpaceRegex = /^[a-zÀ-ÿ]\S*\s$/;

          if (firstWordWithSpaceRegex.test(text)) {
            const transaction = newState.tr;
            const startPos = selection.$anchor.before() + 1;

            transaction.insertText(text[0].toUpperCase(), startPos, startPos + 1);
            transaction.setMeta('addToHistory', false);

            return transaction;
          }

          return null;
        }
      })
    ];
  }
});
